import React from "react";

const InnerBanner = () => {

  return (
    <>
      <div className="general-cleaning-sec-row text-center position-relative">
        {/* <div className="general-cleaning-content general-regular-cleaning-content ">
          <h4> General / Regular Cleaning</h4>
          <p>Book a Domestic Cleaning Service</p>
        </div> */}
          <img src="/assets/images/ProForm-Banner_720by190.png" alt="" />
        {/* <div className="general-img1">
        </div> */}
        {/* <div className="general-img2">
          <img src="/assets/images/Gen_Reg Banner-icon.png" alt="" />
        </div> */}
      </div>

    </>
  );
};

export default InnerBanner;
